import React, {Component} from 'react';
import {Grid, Row, Col, Panel} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify';
import DefinicjeService from "./DefinicjeService";
import PrzystankiService from "../przystanki/PrzystankiService";
import TrasyService from "../trasy/TrasyService";
import DefinicjeTrasSelect from "./components/DefinicjeTrasSelect";
import DefinicjeTrasLista from "./components/DefinicjeTrasLista";
import PokazTraseMapComponent from "../trasy/googleMapComponents/PokazTraseMapComponent";
import {TopAlertUwaga} from "../../../../componentsTopsa/alerty/TopAlerts";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";

export default class DefinicjeTrasContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            definicje: [],
            przystanki: [],
            trasy: [],
            obecna_trasa: null,
            czyPokazacWykrzyknikAktualizuj: false,
            przystankiNaMapie: [],
            czyMoznaPokazacMape: false,
            pokazMarkery: true,
            openPanel: true,
        };
        this.pobierzDefinicjeWTrasie = this.pobierzDefinicjeWTrasie.bind(this);
        this.pobierzDefinicjeWTrasieBezAlertow = this.pobierzDefinicjeWTrasieBezAlertow.bind(this);
        this.pobierzPrzystanki = this.pobierzPrzystanki.bind(this);
        this.pobierzTrasy = this.pobierzTrasy.bind(this);
        this.onSelectTrasa = this.onSelectTrasa.bind(this);
        this.onChangeKolejnosc = this.onChangeKolejnosc.bind(this);
        this.onChangeWartosc = this.onChangeWartosc.bind(this);
        this.onDodajDefinicje = this.onDodajDefinicje.bind(this);
        this.onUsunDefinicje = this.onUsunDefinicje.bind(this);
        this.onAktualizuj = this.onAktualizuj.bind(this);
        this.pokazWykrzyknikAktualizuj = this.pokazWykrzyknikAktualizuj.bind(this);
        this.ukryjWykrzyknikAktualizuj = this.ukryjWykrzyknikAktualizuj.bind(this);
        this.przygotujRekordyNaMape = this.przygotujRekordyNaMape.bind(this);
    }

    componentDidMount() {
        this.pobierzPrzystanki();
        this.pobierzTrasy();
    }

    pobierzDefinicjeWTrasie(trasa_id) {
        DefinicjeService.getDefinicjeWTrasie(trasa_id).then(function (response) {
            this.setState({definicje: response.data})
            this.przygotujRekordyNaMape(response.data)
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie załadowano definicje w wybranej trasie", "", 3000);
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas pobierania definicji ", "", 3000);
            }
        }.bind(this))
    }

    pobierzDefinicjeWTrasieBezAlertow(trasa_id) {
        DefinicjeService.getDefinicjeWTrasie(trasa_id).then(function (response) {
            this.setState({definicje: response.data})
            this.przygotujRekordyNaMape(response.data)
        }.bind(this))
    }

    pobierzPrzystanki() {
        PrzystankiService.getPrzystanki().then(function (response) {
            this.setState({przystanki: response.data.content})
        }.bind(this))
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    onSelectTrasa(trasa) {
        this.setState({obecna_trasa: trasa.idTr})
        this.pobierzDefinicjeWTrasie(trasa.idTr)
    }

    wyroznijButtonAktualizuj() {
        document.getElementById('AktualizujButton').style['background-color'] = 'firebrick';
        document.getElementById('AktualizujButton').style['border-color'] = 'firebrick';
        setTimeout(function () {
            document.getElementById('AktualizujButton').style['background-color'] = '#337ab7';
            document.getElementById('AktualizujButton').style['border-color'] = '#2e6da4';

        }, 1500)
    }

    onChangeKolejnosc(obj) {

        DefinicjeService.editListaDefinicji(obj).then(function (response) {

            if (response.status < 300) {
                this.pobierzDefinicjeWTrasieBezAlertow(this.state.obecna_trasa);
                this.refs.notificator.success("Odświeżono widok po zmianie kolejności", "", 3000)
                this.wyroznijButtonAktualizuj()
                this.pokazWykrzyknikAktualizuj()
            }
            else {
                this.pobierzDefinicjeWTrasieBezAlertow(this.state.obecna_trasa);
                this.refs.notificator.error("Nastąpił błąd podczas próby zmiany kolejności", "", 3000)
            }

        }.bind(this))
    }

    onChangeWartosc(obj) {
        DefinicjeService.editDefinicja(obj.idTd, obj).then(function (response) {
            if (Boolean(this.state.obecna_trasa)) {
                this.pobierzDefinicjeWTrasieBezAlertow(this.state.obecna_trasa)
                this.refs.notificator.success("Pomyślnie zapisano nowe wartości", "", 3000);
                this.wyroznijButtonAktualizuj()
                this.pokazWykrzyknikAktualizuj()
            }
        }.bind(this))
    }

    onDodajDefinicje(obj) {
        DefinicjeService.addDefinicja(obj).then(function (response) {
            if (Boolean(this.state.obecna_trasa)) {
                this.pobierzDefinicjeWTrasieBezAlertow(this.state.obecna_trasa)
                this.refs.notificator.success("Pomyślnie dodano nową definicję", "", 3000);
                this.onAktualizuj();
            }
        }.bind(this))

    }

    onUsunDefinicje(obj) {
        DefinicjeService.deleteDefinicja(obj.idTd).then(function (response) {
            if (Boolean(this.state.obecna_trasa)) {
                this.pobierzDefinicjeWTrasieBezAlertow(this.state.obecna_trasa)
                this.refs.notificator.success("Pomyślnie usunięto definicję", "", 3000);
                this.onAktualizuj();
            }
        }.bind(this))
    }

    onAktualizuj() {
        if (Boolean(this.state.obecna_trasa)) {
            DefinicjeService.getProcedureDefinicja(this.state.obecna_trasa).then(function (response) {
                if (response.status < 300) {
                    this.pobierzDefinicjeWTrasieBezAlertow(this.state.obecna_trasa);
                    this.refs.notificator.success("Pomyślnie zaktualizowano czasy od początku oraz poprzednie przystanki", "", 3000);
                    this.ukryjWykrzyknikAktualizuj();
                }
                else {
                    this.pobierzDefinicjeWTrasieBezAlertow(this.state.obecna_trasa);
                    this.refs.notificator.error("Nastąpił błąd podczas próby zaktualizacji", "", 3000)
                }
            }.bind(this))
        }
    }

    pokazWykrzyknikAktualizuj() {
        this.setState({czyPokazacWykrzyknikAktualizuj: true})
    }

    ukryjWykrzyknikAktualizuj() {
        this.setState({czyPokazacWykrzyknikAktualizuj: false})
    }

    przygotujRekordyNaMape(przystanki) {
        let czyPokazacMape = true;
        let arr;
        if (przystanki.length > 1) {
            arr = Array.from(przystanki, item => {
                if (!(Boolean(item.szGps)) || !(Boolean(item.dlGps))) {
                    czyPokazacMape = false;
                }
                return {
                    idMi: item.idMi,
                    idPr: item.idPr,
                    nazMi: item.nazMi,
                    nazPr: item.nazPr,
                    latlng: {lat: item.szGps, lng: item.dlGps},
                    kol: item.kol
                }
            })
        }
        else {
            czyPokazacMape = false
        }

        this.setState({przystankiNaMapie: arr, czyMoznaPokazacMape: czyPokazacMape})
    }

    render() {

        return (
            <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path} history={this.props.history}
                              collapsedLinks={this.props.collapsedLinks}
                              handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                <Grid fluid={true} id={'DefinicjeTrasContainer'}>
                    <ReactNotify ref='notificator'/>
                    <Row>
                        <Col sm={12}>
                            <div id="subheader">
                                <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                    addressUrl: '/konfiguracja/zarzadzanie-trasami',
                                    text: 'Zarządzanie trasami'
                                }, {addressUrl: '/konfiguracja/zarzadzanie-trasami/przystanki-na-trasie', text: 'Przystanki na trasie'}]}/>
                                <SubHeader currentLink={this.props.match.path} obecnyKalendarz={this.props.obecnyKalendarz}
                                           history={this.props.history}/>
                            </div>
                        </Col>
                        <Col sm={12}>
                            <DefinicjeTrasSelect trasy={this.state.trasy}
                                                 handleSelectTrasa={this.onSelectTrasa}
                                                 handleAktualizuj={this.onAktualizuj}
                                                 czyPokazywacAktualizujBtn={Boolean(this.state.obecna_trasa)}
                                                 czyPokazacWykrzyknikAktualizuj={this.state.czyPokazacWykrzyknikAktualizuj}
                            />
                        </Col>
                        <Col sm={12}>
                            <DefinicjeTrasLista przystanki={this.state.przystanki} definicje={this.state.definicje}
                                                handleChangeKolejnosc={this.onChangeKolejnosc}
                                                handleChangeWartosc={this.onChangeWartosc}
                                                handleDodaj={this.onDodajDefinicje}
                                                handleUsun={this.onUsunDefinicje}
                                                czyPokazywacDodajButton={Boolean(this.state.obecna_trasa)}
                                                obecnaTrasa={this.state.obecna_trasa}
                            />

                        </Col>
                    </Row>
                    <TopIf isTrue={Boolean(this.state.obecna_trasa)}>
                        <Row>
                            <Col xs={12}>
                                {
                                    (this.state.czyMoznaPokazacMape) ?
                                        <div>
                                            <Panel id="collapsible-panel-example-1" expanded={this.state.openPanel}>
                                                <Panel.Heading onClick={() => {
                                                    this.setState({openPanel: !this.state.openPanel})
                                                }}>
                                                    <Panel.Title toggle>
                                                        <a>
                                                            {
                                                                (this.state.openPanel) ?
                                                                    <span><i className={'fa fa-eye-slash'}></i> Ukryj mapę</span>
                                                                    :
                                                                    <span><i className={'fa fa-eye'}></i> Pokaż mapę</span>
                                                            }
                                                        </a>
                                                    </Panel.Title>
                                                </Panel.Heading>
                                                <Panel.Collapse>
                                                    <Panel.Body>
                                                        <div className={'pull-right'}>
                                                            <TopButtonAction onClick={() => {
                                                                this.setState({pokazMarkery: !this.state.pokazMarkery})
                                                            }} text={(this.state.pokazMarkery) ? 'Ukryj markery' : 'Pokaż markery'}
                                                                             btnColor={'primary'}
                                                                             btnSize={'medium'}
                                                                             iconType={'fa fa-map-marker'}/>
                                                        </div>
                                                        <PokazTraseMapComponent trasa={this.state.przystankiNaMapie}
                                                                                pokazMarkery={this.state.pokazMarkery}/>
                                                    </Panel.Body>
                                                </Panel.Collapse>
                                            </Panel>
                                        </div>
                                        :
                                        Boolean(this.state.przystankiNaMapie) ?
                                            (this.state.przystankiNaMapie.length > 1) ?
                                                <TopAlertUwaga
                                                    text={'Nie można pokazać mapy, ponieważ nie uzupełniono wszystkich koordynatów GPS - proszę uzupełnić wartości rekordów.'}/>
                                                :
                                                <TopAlertUwaga
                                                    text={'Nie można pokazać mapy dla trasy mającej mniej niż dwa przystanki - należy uzupełnić rekordy.'}/> :
                                            <TopAlertUwaga
                                                text={'Nie można pokazać mapy dla trasy mającej mniej niż dwa przystanki - należy uzupełnić rekordy.'}/>
                                }
                            </Col>
                        </Row>
                    </TopIf>
                </Grid>
            </SidebarComponent>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/definicjeTras/DefinicjeTrasContainer.js